import { lazy } from "react";

// Lazy-loaded feature chunks — each import() creates a separate bundle chunk
const BannerAllView = lazy(() => import(/* webpackChunkName: "banners-all" */ "@features/banners/banner-all-view"));
const BannerNewView = lazy(() => import(/* webpackChunkName: "banners-new" */ "@features/banners/banner-new-view"));
const FileAllView = lazy(() => import(/* webpackChunkName: "files-all" */ "@features/files/file-all-view"));
const FileNewView = lazy(() => import(/* webpackChunkName: "files-new" */ "@features/files/file-new-view"));
const NotificationAllView = lazy(() => import(/* webpackChunkName: "notifications-all" */ "@features/notifications/notification-all-view"));
const NotificationNewView = lazy(() => import(/* webpackChunkName: "notifications-new" */ "@features/notifications/notification-new-view"));
const PromotionAllView = lazy(() => import(/* webpackChunkName: "promotions-all" */ "@features/promotions/promotion-all-view"));
const PromotionNewView = lazy(() => import(/* webpackChunkName: "promotions-new" */ "@features/promotions/promotion-new-view"));
const SypiAllView = lazy(() => import(/* webpackChunkName: "sypi-db-config" */ "@features/sypi-db-config/sypiV1-all-view"));
const SypiV2 = lazy(() => import(/* webpackChunkName: "sypi-v2" */ "@features/sypi"));
const FileManager = lazy(() => import(/* webpackChunkName: "file-manager" */ "@/features/file-manager"));
const DTPIndex = lazy(() => import(/* webpackChunkName: "dtp" */ "@features/dtp"));
const C3 = lazy(() => import(/* webpackChunkName: "c3" */ "@features/c3"));
const SchemaManagement = lazy(() => import(/* webpackChunkName: "schema-management" */ "@features/schema-management"));
const SelectClientAllView = lazy(() => import(/* webpackChunkName: "select-clients" */ "@features/select-clients/selectClient-all-view"));
const SelectAuthtAllView = lazy(() => import(/* webpackChunkName: "select-auth" */ "@features/select-clients/selectAuth-all-view"));
const DashboardPage = lazy(() => import(/* webpackChunkName: "dashboard" */ "@features/dashboard/dashboardAllView"));
const PnTestingAllView = lazy(() => import(/* webpackChunkName: "pn-testing" */ "@features/pn-testing/pn-testing-all-view"));
const SypiLegacyAllView = lazy(() => import(/* webpackChunkName: "sypi-legacy" */ "@features/sypi-legacy/sypi-legacy-all-view"));

export const ROUTES = {
    home: {
        rootName: "dashboard",
        allViewComponent: DashboardPage,
        options: {
            disableNewPage: true,
            customPath: "",
            defaultStore: true,
        },
    },
    banners: {
        rootName: "banner",
        allViewComponent: BannerAllView,
        newViewComponent: BannerNewView,
        options: { dynamicTitles: true },
    },
    notifications: {
        rootName: "notification",
        allViewComponent: NotificationAllView,
        newViewComponent: NotificationNewView,
        options: { dynamicTitles: true },
    },
    offers: {
        rootName: "offer",
        allViewComponent: PromotionAllView,
        newViewComponent: PromotionNewView,
        options: { dynamicTitles: true },
    },
    files: {
        rootName: "file",
        allViewComponent: FileAllView,
        newViewComponent: FileNewView,
    },
    "select-clients": {
        rootName: "select-client",
        allViewComponent: SelectClientAllView,
        mainContentWrapperStyle: { padding: "0rem" },
        options: {
            disableNewPage: true,
            oneStepAuth: true,
        },
    },
    "select-auth": {
        rootName: "select-auth",
        allViewComponent: SelectAuthtAllView,
        options: {
            disableNewPage: true,
            zeroStepAuth: true,
            callInitFunc: false,
            singularPath: true,
        },
    },
    sypi_db_config: {
        rootName: "sypi_db_config",
        allViewComponent: SypiAllView,
        options: { disableNewPage: true },
    },
    sypiv2: {
        rootName: "sypi",
        customComponent: SypiV2,
    },

    c3: {
        rootName: "c3",
        customComponent: C3,
    },
    "schema-management": {
        rootName: "schema-management",
        customComponent: SchemaManagement,
    },
    filemanager: {
        rootName: "filemanager",
        customComponent: FileManager,
    },
    "pn-testing": {
        rootName: "pn-testing",
        allViewComponent: PnTestingAllView,
        options: {
            disableNewPage: true,
            // callInitFunc: false,
            dynamicTitles: true,
            singularPath: true,
        },
    },
    "sypi-legacy": {
        rootName: "sypi-legacy",
        allViewComponent: SypiLegacyAllView,
        options: {
            disableNewPage: true,
            // callInitFunc: false,
            dynamicTitles: true,
            singularPath: true,
        },
    },
    "dtp-maintenance-mode": {
        rootName: "root",
        customComponent: DTPIndex,
    },

};
